import { Checkbox } from 'antd'
import { useHistory } from 'react-router-dom'
import { PATH } from '../../../constants/router'
import './index.scss'

export default function TermsCheckbox({ checked, onChange }) {
  const history = useHistory()

  const handleLabelClick = () => {
    if (onChange) {
      onChange({ target: { checked: !checked } })
    }
  }

  const handleLinkClick = (e) => {
    e.stopPropagation()
    history.push(PATH.TRAFFIC_FINE_TERMS_OF_SERVICE_PAYMENT)
  }

  return (
    <div className="TermsCheckbox">
      <Checkbox checked={checked} onChange={onChange} className="TermsCheckbox_antCheckbox" />
      <div className="TermsCheckbox_label" onClick={handleLabelClick}>
        <span className="TermsCheckbox_text">
          Tôi đã đọc và đồng ý với các{' '}
          <a
            className="TermsCheckbox_link"
            onClick={handleLinkClick}
          >
            Điều khoản thanh toán và Chính sách bảo vệ dữ liệu cá nhân
          </a>
          , bao gồm việc TAMove thu thập, sử dụng và chia sẻ dữ liệu của tôi trong phạm vi cần thiết để cung cấp dịch vụ.
        </span>
      </div>
    </div>
  )
}
